import React from "react";

/**
 * GlassCard - Primary card component with glass morphism effect
 * TradebotX-inspired: premium hover with lift, glow, gradient border accent
 */
const GlassCard = React.memo(
  React.forwardRef(function GlassCard(
    {
      children,
      className = "",
      hover = true,
      noPadding = false,
      featured = false,
      style = {},
      ...props
    },
    ref
  ) {
    return (
      <div
        ref={ref}
        className={`glass-aurora rounded-2xl animate-fade-in ${hover ? "hover-card" : ""} ${className}`}
        style={{
          position: "relative",
          overflow: "hidden",
          ...(featured
            ? {
                borderTop: "3px solid transparent",
                borderImage: "var(--gradient) 1",
                borderImageSlice: "1 0 0 0",
              }
            : {}),
          ...style,
        }}
        {...props}
      >
        {featured && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: 3,
              background: "var(--gradient)",
            }}
          />
        )}
        {noPadding ? children : <div className="p-6">{children}</div>}
      </div>
    );
  })
);

export default GlassCard;
